/**
 * Initialize newsletter form
 *
 * @class NewsletterForm
 */

import serialize from 'form-serialize';
import xhr from 'xhr';
import { updateToken, loadToken } from './forms';

class NewsletterForm {

  constructor(form) {
    this.form = form;
    this.parent = this.form ? this.form.closest('.js-newsletter-parent') : null;

    if (!this.form || !this.parent) {
      console.warn('class NewsletterForm could not initialize', { class: this });
      return;
    }

    // If window has been resized, height must be re-calculated
    this.form.addEventListener('submit', (e) => {
      this.submit(e);
    });
  }

  submit(e) {
    e.preventDefault();

    this.parent.classList.remove('form-success', 'form-error')

    const data = serialize(this.form, { hash: true });
    const lang = window.stageLanguage || document.documentElement.getAttribute('lang');

    xhr({
      method: 'POST',
      uri: '/stage-ajax/addSubscriber/?stage-language=' + lang,
      body: data,
      json: true,
      headers: {
        'Content-Type': 'application/json'
      }
    }, (err, resp, body) => {
      let success = false;
      if (resp.statusCode === 200 && body.new_subscriber_id) {
        success = true;
      }

      if (success) {
        this.parent.classList.add('form-success');
      } else {
        this.parent.classList.add('form-error');
      }

      // Update tokens for all forms
      if (body.token) {
        updateToken(body.token);
      } else {
        loadToken();
      }
    });
  }

}

export { NewsletterForm };
